import React, { useState,useEffect, useRef } from 'react'
import { useTranslation } from "react-i18next";

import { ConfirmDialog } from 'primereact/confirmdialog'; 
import { Button } from "primereact/button";
const PrimeConfirmDialog=({
    visible=false,
    onConfirm, onClose,
    title = 'Dialog',
    draggable = false,
    bodyTemplate,
    cancelLabel="button.cancel",
    confirmLabel="button.confirm",
    className,
    style={},
    position="center",
})=>{
    const { t } = useTranslation();
    const handleConfirm = () => {
        onConfirm();
    }


    const handleCancel = () => {
        onClose();
    }

    const footerContent = (
        <div>
            <Button onClick={handleConfirm} label={t(confirmLabel)} icon="pi pi-check" size='small'/>
            <Button onClick={handleCancel} label={t(cancelLabel)} icon="pi pi-times" size='small' outlined />
        </div>
    );

    return(
        <ConfirmDialog 
        header={title} 
            visible={visible} 
            onHide={handleCancel}
            footer={footerContent}
            draggable={draggable}
            message={bodyTemplate}
            style={style} 
            className={className}
            position={position}
            maskStyle={{zIndex:"1900"}}
        />
    )
}
export default PrimeConfirmDialog;